import { ContentBlockTypes } from 'api/landingPageTheme'

export const getContentTabAvailable = (type: ContentBlockTypes): boolean => {
  const editContentTabsAvailable: ContentBlockTypes[] = [
    'featured_content',
    'external_form',
  ]
  return editContentTabsAvailable.includes(type)
}
